"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Inventory = function Inventory() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Inventory);

  if (!params.key) {
    throw new Error('Key is required!');
  }

  this.name = params.name || '';
  this.key = params.key || '';
  this.unit = params.unit || '';
  this.date = params.date || '';
  this.quantity = params.quantity ? parseInt(params.quantity, 10) : 0;
  this.printing_cost = params.printing_cost || 0;
  this.shrink_wrapping_cost = params.shrink_wrapping_cost || 0;
  this.category = params.category || params.key;
};

module.exports = Inventory; // printingCost
// shrinkWrappingCost
// testPrintsPrintingCost
// pricingLabelText